import * as Actions from '../../../redux/actions'
import Rating from '@material-ui/lab/Rating';
import React from 'react';
import moment from 'moment'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons'
import { Image } from 'react-bootstrap'
import { DarkTooltip, InstructionsTooltip, LightTooltip } from '../Common/MemberActions/tooltipActions';
import { InfoCircleIcon } from '../Common/SVGBank';
import { MuvInstructionsPopover } from './MuvInstructionsPopover';
import { GetExpediaPaymentOptions } from '../MuvPaymentPage/muvMeta.services';

// Currency symbol map
export const currencySymbols = {
    USD: "$",
    CAD: "CA$",
    EUR: "€",
    GBP: "£",
    AUD: "A$",
    // Extend if needed
};

export const MuvExpediaBasicInfo = ({ cartItem, is_mobile }) => {
    const expediaCost = Object.values(cartItem?.room_json?.occupancy_pricing || {})?.[0]?.nightly?.[0] || [];
    const totals = Object.values(cartItem?.room_json?.occupancy_pricing || {})?.[0]?.totals;

    // Add state for payment options
    const [paymentOptions, setPaymentOptions] = React.useState(null);


    const roomOccupancy = Number(cartItem?.check_in_json?.muvHotel?.roomInfo?.occupancy?.max_allowed.total || 1);


    const checkIn = cartItem?.check_in;
    const checkOut = cartItem?.check_out;
    const rooms = parseInt(cartItem?.check_in_json?.rooms || 1);
    const hotelName = cartItem?.hotel_name;
    const nights = moment(checkOut).diff(moment(checkIn), 'days');


    const propertyFees = Number(totals?.property_fees?.request_currency?.value ?? 0)
    const baseRate = Number(totals?.exclusive?.request_currency?.value ?? 0);
    const totalCost = Number(totals?.inclusive?.request_currency?.value ?? 0);
    const taxesAndFees = totalCost - baseRate;
    let currencyCode = cartItem?.currency || "USD";


    const currencySymbol = "$";
    const taxesAndFeesTotal = taxesAndFees * rooms;
    const totalCostTotal = totalCost * rooms;
    const propertyFeesTotal = propertyFees * rooms;

    const allInTotal = totalCostTotal + propertyFeesTotal;

    const imgWidth = is_mobile ? 150 : 200;
    const hotelImg = cartItem?.hotel_image || "https://via.placeholder.com/200x150?text=Hotel";
    const hotelInfo = cartItem?.check_in_json?.muvHotel?.generalInfo;
    const roomInfo = cartItem?.check_in_json?.muvHotel?.roomInfo;
    const checkInfo = cartItem?.check_in_json?.muvHotel?.checkInfo;
    const roomDetails = cartItem?.room_json;

    const roomName = roomInfo?.name || cartItem?.room_json?.bed_groups?.[Object.keys(cartItem?.room_json?.bed_groups || {})[0]]?.description;

    // const expContent = expHotelRooms?.muvHotelData?.expContent ? Object.values(expHotelRooms?.muvHotelData?.expContent)?.[0] : null;

    const fetchPaymentOptions = async (priceCheckUri) => {
        const paymentOptionsData = await GetExpediaPaymentOptions(priceCheckUri);
        setPaymentOptions(paymentOptionsData);
    };

    React.useEffect(() => {
        const priceCheckUri = cartItem?.room_json?.links?.payment_options?.href;
        if (priceCheckUri) {
            fetchPaymentOptions(priceCheckUri);
        }
    }, [cartItem]);

    // Get processing country from payment options
    const getProcessingCountry = () => {
        if (!paymentOptions?.credit_card?.card_options || !Array.isArray(paymentOptions?.credit_card?.card_options)) {
            return null;
        }

        // Find the first card option with a processing_country
        const cardWithCountry = paymentOptions?.credit_card?.card_options.find(card => card.processing_country);
        return cardWithCountry?.processing_country || null;
    };

    const processingCountry = getProcessingCountry();




    return (
        <div>
            <div style={{ float: "right", display: "inline-block" }}>
                <div style={{ font: is_mobile ? "14px/14px Futura Lt BT" : "18px/21px Futura Lt BT", textAlign: "center" }}>{Number(hotelInfo?.reviewsAverage ?? 0).toFixed(1)}/10</div>
                <div style={{ font: is_mobile ? "14px/14px Futura Lt BT" : "18px/21px Futura Lt BT", textAlign: "center" }}>({hotelInfo?.review_count ?? 0} reviews)</div>
            </div>
            <div style={{ font: is_mobile ? "18px/18px Futura Hv BT" : "24px/24px Futura Hv BT", color: "#000000", marginBottom: 0 }}>
                {hotelName}
                <span className=" timeline_rating_color padding_left_10 padding_right_10 btn_rounded" style={{ marginBottom: "5px" }}>
                    <span style={{ font: "16px/19px Futura Md BT", color: "#707070" }}>
                        <Rating name="timeline_rating" precision={0.5} max={5} value={Number(hotelInfo?.star_rating)} disabled={true} /> ({Number(hotelInfo?.star_rating)})
                    </span>
                </span>
            </div>
            <div
                style={{
                    font: is_mobile ? "12px/22px Futura Md BT" : "18px/24px Futura Md BT",
                    color: "#707070",
                    marginBottom: "15px",
                }}
            >
                {[
                    hotelInfo?.address,
                    hotelInfo?.city_name || hotelInfo?.cityName,
                    hotelInfo?.neighborhood || hotelInfo?.city?.neighborhood,
                    hotelInfo?.state_name || hotelInfo?.stateName || hotelInfo?.city?.state,
                    // hotelInfo?.countryName || hotelInfo?.country,
                    // hotelInfo?.postalCode,
                ]
                    .filter(Boolean)
                    .join(', ')}
            </div>

            <div style={{ width: "100%", marginTop: 10 }}>
                <div style={{ display: "flex", flexWrap: "wrap", width: "100%", marginTop: 10, gap: is_mobile ? "1rem" : "2rem" }}>
                    {/* LEFT: Image */}
                    <div style={{ flexShrink: 0, width: imgWidth, marginBottom: "1rem" }}>
                        <Image
                            style={{ width: "100%", height: imgWidth, objectFit: "cover", objectPosition: "center" }}
                            src={roomInfo?.images?.[0]?.links["1000px"]?.href ||
                                "https://amhqajbken.cloudimg.io/v7/_muvestab_/000_c…on/grayBackgroundCamera.jpg?func=crop&w=359&h=300"}
                        />
                    </div>

                    {/* RIGHT: Room and price info */}
                    <div style={{ flex: 1, minWidth: 210, marginTop: 10 }}>
                        <div style={{ borderBottom: "1px solid #E8E8E8", paddingBottom: 10, marginBottom: 10 }}>
                            <div style={{ font: is_mobile ? "12px/18px Futura Lt BT" : "18px/24px Futura Lt BT", color: "var(--mainBlack)", marginBottom: 10 }}>
                                {nights} night(s), {rooms} room(s)
                            </div>
                            <div style={{ font: is_mobile ? "12px/18px Futura Lt BT" : "18px/24px Futura Lt BT", color: "var(--mainBlack)", marginBottom: 10 }}>
                                <div style={{ width: "8rem", display: "inline-block" }}>Check-in:
                                    <div style={{ marginLeft: -10, display: "inline-block" }}>
                                        <MuvInstructionsPopover checkInfo={checkInfo} />
                                    </div>

                                </div>
                                <div style={{ font: is_mobile ? "14px/18px Futura Md BT" : "20px/24px Futura Md BT", display: "inline-block" }}>
                                    {moment(checkIn).format('ddd, MMMM Do, yyyy')}
                                </div>

                            </div>
                            <div style={{ font: is_mobile ? "12px/18px Futura Lt BT" : "18px/24px Futura Lt BT", color: "var(--mainBlack)" }}>
                                <div style={{ width: "8rem", display: "inline-block" }}>Check-out:</div>
                                <div style={{ font: is_mobile ? "14px/18px Futura Md BT" : "20px/24px Futura Md BT", display: "inline-block" }}>
                                    {moment(checkOut).format('ddd, MMMM Do, yyyy')}
                                </div>
                            </div>
                        </div>

                        <div style={{ borderBottom: "1px solid #E8E8E8", paddingBottom: 10, marginBottom: 10 }}>
                            <div style={{ font: "18px/32px Futura Hv BT", color: "var(--mainBlack)", marginBottom: 5 }}>
                                {rooms > 1 ? `Rooms(1-${rooms}):` : "Room 1:"}
                            </div>
                            <div style={{ font: "18px/32px Futura Hv BT", color: "var(--mainBlack)", marginBottom: 10 }}>
                                {roomName} {roomOccupancy > 0 ? <span style={{ font: "18px/32px Futura Md BT" }}> (max occupancy: {roomOccupancy})</span> : ""}
                            </div>
                            <div style={{ marginTop: 10, marginBottom: "10px", font: "16px/16px Futura Lt BT", color: "var(--mainGrey)" }}>
                                {renderCancellationPolicy(roomDetails?.refundable, roomDetails?.cancel_penalties)}
                            </div>

                            {processingCountry && (
                                <div style={{ marginTop: 10, marginBottom: "10px", font: "16px/16px Futura Lt BT", color: "var(--mainGrey)" }}>
                                    This payment will be processed in the {processingCountry}.
                                </div>
                            )}
                            <div style={{ display: "flex", font: "14px/16px Futura Lt BT", color: "var(--mainBlack)", marginBottom: 5, gap: 2 }}>
                                {/* You can show cancellation or breakfast status here if desired */}
                            </div>
                        </div>

                        <div style={{ marginTop: 10, justifyContent: "space-between", marginBottom: "15px", font: "16px/16px Futura Lt BT", color: "var(--mainBlack)", display: "flex" }}>
                            <div>Price ({rooms} room(s) x {nights} night(s)):</div>
                            <div style={{ textAlign: "right" }}>{currencySymbol}{(baseRate * rooms).toFixed(2)}</div>
                        </div>

                        <div style={{ marginTop: 10, justifyContent: "space-between", marginBottom: "10px", font: "16px/16px Futura Lt BT", color: "var(--mainBlack)", display: "flex" }}>

                            <div style={{ width: "12rem", display: "inline-block" }}>Taxes and Fees:
                                <div style={{ marginLeft: -10, display: "inline-block" }}>
                                    <MuvInstructionsPopover text={"The taxes are tax recovery charges paid to vendors (e.g.,hotels); for details please see our Terms of Use. Service fees are retain as compensation in servicing your booking and may include fees charged by vendors"} />
                                </div>

                            </div>
                            <div style={{ textAlign: "right" }}>{currencySymbol}{(taxesAndFeesTotal).toFixed(2)}</div>
                        </div>

                        <div style={{ marginTop: 20, justifyContent: "space-between", marginBottom: "10px", font: "16px/16px Futura Lt BT", color: "var(--mainBlack)", display: "flex" }}>
                            <div style={{ font: "16px/16px Futura Md BT" }}>
                                TOTAL<span style={{ font: "16px/16px Futura Lt BT" }}> (Pay now):</span>
                            </div>

                            <div style={{ textAlign: "right", font: "16px/16px Futura Md BT" }}>
                                <span style={{ font: "13px/16px Futura Md BT" }}>{currencyCode}</span>{currencySymbol}{totalCostTotal.toFixed(2)}
                            </div>


                        </div>

                        {propertyFees ? <div style={{ marginTop: 20, justifyContent: "space-between", marginBottom: "10px", font: "16px/16px Futura Lt BT", color: "var(--mainBlack)", display: "flex" }}>
                            <div>Property Fees (due at the property):
                                <div style={{ marginLeft: -10, display: "inline-block" }}>
                                    <MuvInstructionsPopover html={checkInfo?.fees?.mandatory}
                                        htmlTitle="Property Fees"
                                    />
                                </div>
                            </div>
                            <div style={{ textAlign: "right" }}>{currencySymbol}{(propertyFeesTotal).toFixed(2)}</div>

                        </div> : ''}

                        <div style={{ marginTop: 20, justifyContent: "space-between", marginBottom: "3px", font: "16px/16px Futura Lt BT", color: "var(--mainBlack)", display: "flex" }}>
                            <div style={{ font: "16px/16px Futura Md BT" }}>
                                Your total cost <span style={{ font: "16px/16px Futura Lt BT" }}>(inclusive of all taxes and fees):</span>
                            </div>
                            <div style={{ textAlign: "right", font: "16px/16px Futura Md BT" }}>
                                <span style={{ font: "13px/16px Futura Md BT" }}>{currencyCode}</span>{currencySymbol}{allInTotal.toFixed(2)}
                            </div>
                        </div>

                    </div>
                </div>


            </div>
        </div >
    );
};

const renderCancellationPolicy = (refundable, cancelPenalties) => {
    try {
        if (!refundable) {
            return (
                <div style={{ padding: 0, paddingTop: 0, font: "14px/20px Futura Lt BT" }}>
                    This rate is non-refundable.
                </div>
            );
        }

        const penalty = Array.isArray(cancelPenalties) ? cancelPenalties[0] : null;
        const start = penalty?.start;
        const percent = penalty?.percent;
        const nights = penalty?.nights;

        if (start && moment(start).isValid()) {
            const startMoment = moment(start);

            // Get user's local timezone abbreviation
            const getUserTimezoneAbbr = (date) => {
                const formatOptions = { timeZoneName: 'short' };
                const formatter = new Intl.DateTimeFormat(undefined, formatOptions);
                const parts = formatter.formatToParts(date.toDate());
                const tzPart = parts.find(part => part.type === 'timeZoneName');
                return tzPart ? tzPart.value : '';
            };

            const abbr = getUserTimezoneAbbr(startMoment);
            const hasPassed = startMoment.isBefore(moment());

            const cancelUntil = startMoment.format(`MMMM Do [@] h:mm A`) + ` ${abbr}` + (hasPassed ? " (date passed)" : "");

            let refundText = '';
            if (nights) {
                refundText = `${nights} night${nights > 1 ? 's' : ''} penalty`;
            } else if (percent) {
                refundText = `${percent} refundable`;
            } else {
                refundText = `100% refundable`;
            }

            return (
                <div style={{ padding: 0, paddingTop: 0, font: "14px/20px Futura Lt BT" }}>
                    This rate is cancellable until <strong>{cancelUntil}</strong>, {refundText}.
                </div>
            );
        }

        // refundable but no penalty info
        return (
            <div style={{ padding: 0, paddingTop: 0, font: "14px/20px Futura Lt BT" }}>
                This rate is cancellable and refundable.
            </div>
        );
    } catch (err) {
        console.error("Error rendering cancellation policy:", err);
        return null;
    }
};
